import { GridState } from "../gridState";
import { GridDimension } from "client/Api/Workspace/common";
import { IPackingAlgorithm } from "./common";
import { sortBy } from "client_legacy/ndaw/arrayHelpers";


class TopPackingAlgorithm implements IPackingAlgorithm {

	public applyTo<TItem>(state: GridState<TItem>) {
		const currentDimension: GridDimension = state.dimension;
		const numberOfColumns: number = currentDimension.columnSpan;
		const numberOfRows: number = currentDimension.rowSpan;
		const orderedGridItems = sortBy(
			state.gridItems,
			(gridItem) => gridItem.position.row
		);

		// Create an (x, y) array for tracking which cells are empty
		const cellTracker = new Array(numberOfColumns);
		for (let column = 0; column < numberOfColumns; column++) {
			cellTracker[column] = new Array(numberOfRows);
			for (let row = 0; row < numberOfRows; row++) {
				cellTracker[column][row] = false;
			}
		}

		// Fill the tracker with information what cells are not empty
		for (const gridItem of orderedGridItems) {
			for (let column = gridItem.position.column; column < gridItem.position.column + gridItem.dimension.columnSpan; column++) {
				for (let row = gridItem.position.row; row < gridItem.position.row + gridItem.dimension.rowSpan; row++) {
					cellTracker[column][row] = true;
				}
			}
		}

		for (const gridItem of orderedGridItems) {
			for (let newRow = gridItem.position.row - 1; newRow >= 0; newRow--) {

				let areaIsFree: boolean = true;
				for (let column = gridItem.position.column; column < gridItem.position.column + gridItem.dimension.columnSpan; column++) {
					const isCellFilled: boolean = cellTracker[column][newRow];
					if (isCellFilled) {
						areaIsFree = false;
						break;
					}
				}

				if (!areaIsFree) {
					break;
				}

				for (let column = gridItem.position.column; column < gridItem.position.column + gridItem.dimension.columnSpan; column++) {
					cellTracker[column][newRow] = true;
					cellTracker[column][newRow + gridItem.dimension.rowSpan] = false;
				}
				gridItem.position.row--;
			}
		}
	}
}

export {
	TopPackingAlgorithm
};
